<template>
  <div
    class="saas-section"
    :class="[
      {
        'saas-section--gray': block.background === 'gray',
        'saas-section--light-to-dark': block.background === 'light_to_dark',
        'saas-section--dark-to-light': block.background === 'dark_to_light',
      },
    ]"
  >
    <div
      v-if="block.title"
      class="saas-section__title"
      :class="{ 'saas-section__title--wide': block.wide }"
    >
      <h2 class="saas-striped-title">{{ block.title }}</h2>
    </div>
    <div v-if="block.text" class="saas-section__description">
      {{ block.text }}
    </div>
    <PageIconContainer
      v-if="block.contained"
      :icons="block.usps"
    ></PageIconContainer>
    <PageIconGrid v-else :icons="block.usps"></PageIconGrid>
  </div>
</template>
<script>
import PageIconContainer from '@saas/components/page/PageIconContainer'
import PageIconGrid from '@saas/components/page/PageIconGrid'

export default {
  name: 'PageBlockIconGrid',
  components: { PageIconContainer, PageIconGrid },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
}
</script>
